import { BaseRestDataProvider } from './BaseRestDataProvider';
import { VatRate } from '../models/VatRate';

export class VatRateRestDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/vat-rates');
  }

  getAll(): Promise<VatRate[]> {
    return this.get<VatRate[]>(``);
  }

  getById(id: string): Promise<VatRate> {
    return this.get<VatRate>(`/${id}`);
  }

  add(vatRate: VatRate): Promise<VatRate> {
    return this.post<VatRate>(``, vatRate);
  }

  update(id: string, vatRate: VatRate): Promise<void> {
    return this.put<void>(`/${id}`, vatRate);
  }

  delete(id: string): Promise<void> {
    return super.delete(`/${id}`);
  }
}

export type { VatRate };
